









































































import { Component, Prop, Vue } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import { storeResume } from "@/store/modules/resume";
import { storeSpri } from "@/store/modules/spri";
import { storeSuratRujukanRanap } from "@/store/modules/SuratRujukanRanap";
import SuketPulang from "@/store/modules/SuketPulang";
import SuketGawatDarurat from "@/store/modules/SuketGawatDarurat";
import SuketKematian from "@/store/modules/SuketKematian";
import AsesmenGadarMedisStore from "@/store/modules/AsesmenAwalGadar/AsesmenGadarMedisStore";
import SoapRanapStore from "@/store/modules/SoapRanapStore";
import { adaSoapRegister, pickSoapDokterTerakhir } from "@/utils/spriFromSoap";
import SuketPulangCard from "@/components/pemeriksaan/resumeSuketV2/SuketPulangCard.vue";
import CardResumeRalanIgd from "@/components/pemeriksaan/resumeSuketV2/CardResumeRalanIgd.vue";
import SuketGawatDaruratTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/SuketGawatDaruratTabPage.vue";
import SuketKematianTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/SuketKematianTabPage.vue";
import SpriTabPage from "@/pages/PemeriksaanPage/SuratKeteranganTabPage/SpriTabPage.vue";
import CardSuratRujukanRanap from "@/components/pemeriksaan/konsulRujukan/CardSuratRujukanRanap.vue";

@Component({
  components: {
    SuketPulangCard,
    CardResumeRalanIgd,
    SuketGawatDaruratTabPage,
    SuketKematianTabPage,
    SpriTabPage,
    CardSuratRujukanRanap
  }
})
export default class BundelSuketGadar extends Vue {
  @Prop() readonly register!: number;
  @Prop() readonly rm!: number;

  suketActive = null;

  get stateUser() {
    return userModule.user;
  }

  get paramResume() {
    return {
      reg: this.register,
      idUser: this.stateUser.id
    };
  }

  get disableSuketButtons() {
    return !AsesmenGadarMedisStore.asesmen;
  }

  get soapCpptDokter() {
    return pickSoapDokterTerakhir(SoapRanapStore.soap, this.register);
  }

  btnDisabled(btn) {
    return btn.type === "spri" ? !this.soapCpptDokter : this.disableSuketButtons;
  }

  get suketButtons() {
    return [
      {
        type: "suket-pulang",
        title: "Suket Pulang",
        component: "SuketPulangCard",
        data: SuketPulang.suket,
        canInstantCreate: false,
        loading: SuketPulang.loading
      },
      {
        type: "suket-gadar",
        title: "Suket Gawat Darurat",
        component: "SuketGawatDaruratTabPage",
        data: SuketGawatDarurat.suket,
        canInstantCreate: false,
        loading: SuketGawatDarurat.loading
      },
      {
        type: "suket-mati",
        title: "Suket Kematian",
        component: "SuketKematianTabPage",
        data: SuketKematian.suket,
        canInstantCreate: false,
        loading: SuketKematian.loading
      },
      {
        type: "resume-ralan",
        title: "Resume Ralan IGD",
        component: "CardResumeRalanIgd",
        data: storeResume.resume.length,
        canInstantCreate: false,
        loading: storeResume.loading
      },
      {
        type: "spri",
        title: "SPRI",
        component: "SpriTabPage",
        data: storeSpri.spri.length,
        canInstantCreate: false,
        loading: storeSpri.loading
      },
      {
        type: "rujukan-ranap",
        title: "Surat Rujukan",
        component: "CardSuratRujukanRanap",
        data: storeSuratRujukanRanap.rujukan,
        canInstantCreate: true,
        loading: storeSuratRujukanRanap.loading
      }
    ];
  }

  async mounted() {
    if (!this.register) return;

    if (String(AsesmenGadarMedisStore.registerId) !== String(this.register)) {
      await AsesmenGadarMedisStore.getByRegister(this.register);
    }

    if (!adaSoapRegister(SoapRanapStore.soap, this.register)) {
      SoapRanapStore.getByRegister(this.register);
    }

    SuketPulang.getSuketByRegister(this.register);
    SuketGawatDarurat.getSuketByRegister(this.register);
    SuketKematian.getSuketByRegister(this.register);
    storeResume.act_resume_on_reg(this.paramResume);
    storeSpri.act_spri_on_reg(this.register);
    storeSuratRujukanRanap.getByRegister(this.register);
  }

  showSuketContent(type) {
    this.suketActive = type;

    if (type == "suket-pulang") {
      SuketPulang.getSuketByRegister(this.register);
    }

    if (type == "suket-gadar") {
      SuketGawatDarurat.getSuketByRegister(this.register);
    }

    if (type == "suket-mati") {
      SuketKematian.getSuketByRegister(this.register);
    }

    if (type == "resume-ralan") {
      storeResume.act_resume_on_reg(this.paramResume);
    }

    if (type == "spri") {
      storeSpri.act_spri_on_reg(this.register);
    }

    if (type == "rujukan-ranap") {
      storeSuratRujukanRanap.getByRegister(this.register);
    }
  }
}
